<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title"></div>
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        :class="['btn btn-sm btn-outline-filter', filterUiState('fireResistance', 'F-30-B')]"
        v-on:click="selectValue('F-30-B')">F 30-B</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionFireResistance',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'Feuer&shy;wider&shy;stand'
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      const title = 'F-30-B'

      const uiState = this.filterUiState('fill', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('&shy;').join(''),
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: null
      })

      this.$store.dispatch('filter/setValue', {
        name: 'fireResistance',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
